import { loadLoyaltyIsBenefitAvailable } from ".";
import { MEMBERS_ONLY_SALE } from "..";

const loadLoyaltyIsMembersOnlySaleAvailableForTier = () =>
  loadLoyaltyIsBenefitAvailable(MEMBERS_ONLY_SALE);

export default loadLoyaltyIsMembersOnlySaleAvailableForTier;
